import { Stack } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";

import { IntegrationScreenContext } from "../context/IntegrationScreenContext.ts";
import { IntegrationScreenHelper } from "../context/IntegrationScreenHelper.ts";
import { IntegrationBreadcrumbs } from "./IntegrationBreadcrumbs.tsx";
import { PhysitrackCard } from "./PhysitrackCard.tsx";
import { PhysitrackProviderCard } from "./PhysitrackProviderCard.tsx";

const PhysitrackPage: React.FC = () => {
  const root = useStores();
  return (
    <IntegrationScreenContext.Provider
      value={new IntegrationScreenHelper(root)}
    >
      <IntegrationBreadcrumbs />
      <Stack tokens={{ childrenGap: 24 }}>
        <PhysitrackCard />
        <PhysitrackProviderCard />
      </Stack>
    </IntegrationScreenContext.Provider>
  );
};

// ⚠ It should be exported as default since it is used for React.lazy
// eslint-disable-next-line import/no-default-export
export default PhysitrackPage;
